import { BellRing } from 'lucide-react';
import { Button, Modal } from '../../components/ui';
import { native } from '../../lib/native';
import { usePushState } from '../../lib/pushState';

/**
 * Android app only: explains what notifications are for before Android's own permission dialog appears.
 * Shown once, after the first sign-in on the phone; Settings → Notifications can turn them on later.
 */
export function PushPrompt() {
  const visible = usePushState((s) => s.promptVisible);
  if (!native) return null;
  const app = native;
  return (
    <Modal
      open={visible}
      onClose={() => app.push.dismissPrompt()}
      title="Get notified about messages?"
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={() => app.push.dismissPrompt()}>
            Not now
          </Button>
          <Button icon={BellRing} onClick={() => void app.push.enable()}>
            Turn on
          </Button>
        </>
      }
    >
      <p className="text-sm text-muted">
        Spawnwire can tell you about direct messages, mentions and friend requests even when the app is closed or your screen is off. Muted conversations and Do not disturb stay
        quiet, and you can choose what notifies you per space and channel.
      </p>
    </Modal>
  );
}
